import { upperFirst } from 'lodash';

export function convertToSentence(input: string): string {
  const capitalized = upperFirst(input);
  const stringWithDot = capitalized.endsWith('.')
    ? capitalized
    : capitalized + '.';
  return stringWithDot;
}
